// src/components/SidebarDrawerToggle.jsx
import React from 'react';
import { SlDrawer } from 'react-icons/sl';
import { IoMdBook, IoMdMicrophone } from 'react-icons/io';
import { FaRegClock } from 'react-icons/fa';

function SidebarDrawerToggle({
    isUnscheduledDrawerOpen,
    setIsUnscheduledDrawerOpen,
    isEventDrawerOpen,
    setIsEventDrawerOpen,
    isMeetingDrawerOpen,
    setIsMeetingDrawerOpen
}) {
    const handleUnscheduledToggle = () => {
        if (isUnscheduledDrawerOpen) {
            setIsUnscheduledDrawerOpen(false);
        } else {
            setIsEventDrawerOpen(false);
            setIsMeetingDrawerOpen(false);
            setIsUnscheduledDrawerOpen(true);
        }
    };

    const handleEventToggle = () => {
        if (isEventDrawerOpen) {
            setIsEventDrawerOpen(false);
        } else {
            setIsUnscheduledDrawerOpen(false);
            setIsMeetingDrawerOpen(false);
            setIsEventDrawerOpen(true);
        }
    };

    const handleMeetingToggle = () => {
        if (isMeetingDrawerOpen) {
            setIsMeetingDrawerOpen(false);
        } else {
            setIsUnscheduledDrawerOpen(false);
            setIsEventDrawerOpen(false);
            setIsMeetingDrawerOpen(true);
        }
    };

    return (
        <>
            {/* Unscheduled Toggle Button */}
            <button
                onClick={handleUnscheduledToggle}
                className="absolute top-4 left-1 z-10 bg-white border border-gray-200 rounded-full p-2 hover:shadow-lg transition-all duration-200 hover:bg-gray-50"
                title={isUnscheduledDrawerOpen ? 'Close drawer' : 'Open Unscheduled Courses'}
            >
                {isUnscheduledDrawerOpen ? (
                    <svg
                        className="w-6 h-6 text-gray-600 transition-transform duration-200 rotate-180"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                ) : (
                    <IoMdBook className="w-6 h-6 text-gray-600" />
                )}
            </button>

            {/* Event Toggle Button */}
            <button
                onClick={handleEventToggle}
                className="absolute top-16 left-1 z-10 bg-white border border-gray-200 rounded-full p-2 hover:shadow-lg transition-all duration-200 hover:bg-gray-50"
                title={isEventDrawerOpen ? 'Close events' : 'Open Events'}
            >
                {isEventDrawerOpen ? (
                    <svg
                        className="w-6 h-6 text-gray-600 transition-transform duration-200 rotate-180"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                ) : (
                    <IoMdMicrophone className="w-6 h-6 text-gray-600" />
                )}
            </button>

            {/* Meeting Toggle Button */}
            <button
                onClick={handleMeetingToggle}
                className="absolute top-28 left-1 z-10 bg-white border border-gray-200 rounded-full p-2 hover:shadow-lg transition-all duration-200 hover:bg-gray-50"
                title={isMeetingDrawerOpen ? 'Close meetings' : 'Open Meetings'}
            >
                {isMeetingDrawerOpen ? (
                    <svg
                        className="w-6 h-6 text-gray-600 transition-transform duration-200 rotate-180"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                ) : (
                    <FaRegClock className="w-6 h-6 text-gray-600" />
                )}
            </button>
        </>
    );
}

export default SidebarDrawerToggle;
